import { openNewTab, validateUrl } from '../helpers';

export default function eventLineup() {
  const widgetName = 'eventLineup';
  const widgetOpts = eventLineupOpts;

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
      $(`#${widgetName} .arrows`).addClass('slides-' + response.Slides.length);
      $(`#${widgetName} .swiper-wrapper`).addClass('slides-' + response.Slides.length);

      response.Slides.forEach(function (slide) {
        swiperWidgetWrapper.append(buildSlideTemplate(slide));
      });
      initSwiper(widgetName, response.Slides.length);
    } else {
      $('.eventLineup-container').remove();
    }
  });
}

// ------------------------------
// ------------------------------
// Swiper Initialization
function initSwiper(widget, slidesCount) {
  const funSwiper = new Swiper(`#${widget} .swiper-container`, {
    loop: false,
    watchOverflow: true,
    freeMode: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    grabCursor: true,
    autoHeight: true,
    navigation: {
      nextEl: `#${widget} .swiper-button-next`,
      prevEl: `#${widget} .swiper-button-prev`,
    },
    centeredSlides: false,
    slidesPerView: slidesCount == 5 ? 5 : slidesCount,
    spaceBetween: 10,
    breakpoints: {
      650: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slidesCount > 1,
      },

      880: {
        slidesPerView: slidesCount >= 2 ? 2 : 1,
        loop: slidesCount > 2,
      },

      1135: {
        slidesPerView: Math.min(3, slidesCount),
        loop: slidesCount > 3,
      },

      1245: {
        slidesPerView: Math.min(4, slidesCount),
        loop: slidesCount > 4,
      },

      1300: {
        slidesPerView: slidesCount == 5 ? 5 : slidesCount,
      },
    },
  });

  return funSwiper;
}

// ------------------------------
// Swiper container structure
const swiperContainers = `
    <div class="swiper-button-prev arrows"></div>
      <div class="swiper-container">
          <div class="swiper-wrapper">
          </div>
      </div>
    <div class="swiper-button-next arrows"></div>
  `;

// ------------------------------
// Slide Template
function buildSlideTemplate(slide) {
  const { Title, URL, ImageWithPath, ImageAlternateText, DateRange } = slide;
  const dates = splitDates(DateRange);

  const template = `
    <div class="swiper-slide">

      <div class="swiper-lineup${validateUrl(URL, 'class')}"  ${validateUrl(URL, 'index')}>
        <div class="swiper-content-container">
          ${dates}                
          <div class="swiper-image-container swiper-lazy" style="background-image:url('${ImageWithPath}')" data-background="${ImageWithPath}" aria-label="${ImageAlternateText}">
            <div class="overlay"></div>
            ${URL ? `<a href="${URL}" class="button" ${openNewTab(URL)}>More</a>` : ''}
          </div>
        </div>
      </div>

      <div class="swiper-text-container">
        <h3>${Title}</h3>
      </div>
    </div>
    `;

  return template;
}

// ------------------------------
// Dates extraction
function splitDates(dates) {
  let fixedDate = dates.split('-');
  let dayStart;
  let monthStart;
  let dayEnd;
  let monthEnd;
  let dateLayout;

  switch (fixedDate.length) {
    case 1:
      dayStart = formatDate(fixedDate, 0, 0, 1);
      monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
      dateLayout = buildEventDateLayout(monthStart, dayStart);
      break;

    case 2:
      monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
      dayStart = formatDate(fixedDate, 0, 0, 1);
      monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
      dayEnd = formatDate(fixedDate, 1, 0, 1);
      dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
      break;

    default:
      break;
  }

  return dateLayout;
}

// ------------------------------
// Dates helper
function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  return splittedDate;
}

// ------------------------------
// Dates structure
function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null,
) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
            <div class="event-date ">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}</span>
            </div>`;
  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
            <div class="event-date double-date">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}<span class="divider">-</span>${eventEndDay}</span>
            </div>`;
  } else {
    dateLayout = `
            <div class="event-date date-range">
                <div class="combo-date">
                    <span class="month">${eventStartMonth}</span>
                    <span class="day">${eventStartDay}</span>
                    </div>
                    
                <span class="divider-month">-</span>
  
                <div class="combo-date">
                    <span class="month">${eventEndMonth}</span>
                    <span class="day">${eventEndDay}</span>
                </div>
            </div>`;
  }
  return dateLayout;
}
